/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { NetCloudIcon16Light } from './NetCloudIcon16Light';
import { NetCloudIcon16Regular } from './NetCloudIcon16Regular';
import { NetCloudIcon16Solid } from './NetCloudIcon16Solid';
import { NetCloudIcon20Light } from './NetCloudIcon20Light';
import { NetCloudIcon20Regular } from './NetCloudIcon20Regular';
import { NetCloudIcon20Solid } from './NetCloudIcon20Solid';
import { NetCloudIcon24Regular } from './NetCloudIcon24Regular';
import { NetCloudIcon24Solid } from './NetCloudIcon24Solid';
import { NetCloudIcon32Regular } from './NetCloudIcon32Regular';
import { NetCloudIcon64Regular } from './NetCloudIcon64Regular';
var sizes = {
    16: {
        light: NetCloudIcon16Light,
        regular: NetCloudIcon16Regular,
        solid: NetCloudIcon16Solid,
    },
    20: {
        light: NetCloudIcon20Light,
        regular: NetCloudIcon20Regular,
        solid: NetCloudIcon20Solid,
    },
    24: {
        regular: NetCloudIcon24Regular,
        solid: NetCloudIcon24Solid,
    },
    32: {
        regular: NetCloudIcon32Regular,
    },
    64: {
        regular: NetCloudIcon64Regular,
    },
};
export var NetCloudIcon = forwardRef('NetCloudIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
